import { useTranslation } from 'react-i18next';
import { TeleportIcon } from '@icons';
import { useMytaverseEvent } from '@core/dashboard/providers';
import HomeBarButton from '../../HomeBarButton';
import { NOTIFICATION_TYPES, useNotification } from '@components/Notification';
import { getClientSpecificCanTeleport } from '@helpers/clientSpecificUtils';
import { getNotification } from '@components/Notification/helpers';
import { Box } from '@mui/material';
import {
  useClientSpecificDashboardButtonDisabled,
  useClientSpecificTeleportVisibility,
} from '@hooks/clientSpecificUtils';
import { DashboardButtonEnum } from '@constants/dashboard';
import { useTeleportOpen } from '@core/dashboard/components/TeleportModal/hooks/useTeleportOpen';

const Teleport = () => {
  const { t: translate } = useTranslation();
  const {
    isTeleportingToRoomByUnreal,
    currentEvent,
    teleportEnabled,
  } = useMytaverseEvent();
  const { showNotification } = useNotification();
  const { canTeleport, notificationMessage } =
    getClientSpecificCanTeleport(currentEvent);

  const isDisabledClientSpecific = useClientSpecificDashboardButtonDisabled(
    DashboardButtonEnum.TELEPORT_BUTTON,
  );
  const { isTeleportFeatureEnabled } = useClientSpecificTeleportVisibility();

  const { toggleTeleport, open: isTeleportModalOpen, hasMapTeleportPreviews } =
    useTeleportOpen();

  const handleTeleportClick = () => {
    toggleTeleport();
  };

  const showNotificationIfCantTeleport = () => {
    showNotification(
      getNotification({
        message: translate(`notifications.${notificationMessage}`),
        type: NOTIFICATION_TYPES.INFO,
        closeManually: false,
        withDismissButton: false,
        withReloadButton: false,
      }),
    );
  };

  if (teleportEnabled && isTeleportFeatureEnabled) {
    return (
      <Box
        onClick={() => {
          !canTeleport && showNotificationIfCantTeleport();
        }}
      >
        <HomeBarButton
          handleClick={handleTeleportClick}
          icon={<TeleportIcon />}
          label={translate('tooltips.teleport')}
          isActive={
            hasMapTeleportPreviews
              ? isTeleportModalOpen
              : isTeleportingToRoomByUnreal
          }
          disabled={!canTeleport || isDisabledClientSpecific}
        />
      </Box>
    );
  } else {
    return null;
  }
};

export default Teleport;
